export interface UpcomingDispatchesQueryResponse {
	data: {
		upcomingDispatches: Dispatch[];
	};
};

export interface Label {
	label: string;
	locale: string;
}

export interface Dispatch {
	event_nodes: EventNode[];
	program_name: Label[];
	portfolio_name: Label[];
	full_time_zone: string;
}

export interface EventNode {
	event_node_id: string;
	organization_name: Label[];
	site_display_label: Label[];
	event_node_start_dttm_utc: string;
	event_node_end_dttm_utc: string;
}

export enum DispatchStatus {
	Upcoming = 'upcoming',
	None = 'none',
	Ongoing = 'ongoing',
	RecentlyEnded = 'recentlyEnded'
}

export interface DispatchViewModel {
	id: string;
	org: string;
	site: string;
	program: string;
	portfolio: string;
	startUtc: string;
	endUtc: string;
	status: DispatchStatus;
	timeZone: string;
}

export interface DispatchesQueryResponse {
  data: {
    dispatches: Dispatch[];
  };
}